// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","topBackground":"TopBackground_topBackground__Eind5"};